import { AnyAction } from 'redux'

import { IUserState } from '../types'
import {
  SET_IS_PERSONAL_DATA_ALLOWED,
  SET_STATUS,
  SET_TEST_ENVIRONMENT_QUERY_PARAM,
  SET_UTM_TAGS,
  SET_UUID,
  UPDATE_USER_CONFIG,
} from './actions'

const initState: IUserState = {
  uuid: '',
  status: null,
  testEnvironmentQueryParam: '',
  utmTags: null,
}

export function userReducer(
  state: IUserState = initState,
  { type, payload = null }: AnyAction,
): IUserState {
  switch (type) {
    case SET_UUID: {
      return {
        ...state,
        uuid: payload,
      }
    }
    case SET_STATUS: {
      return {
        ...state,
        status: payload,
      }
    }
    case SET_TEST_ENVIRONMENT_QUERY_PARAM: {
      return {
        ...state,
        testEnvironmentQueryParam: payload,
      }
    }
    case SET_UTM_TAGS: {
      return {
        ...state,
        utmTags: payload,
      }
    }
    case UPDATE_USER_CONFIG: {
      return {
        ...state,
        ...(state.status && {
          status: {
            ...state.status,
            config: {
              ...state.status.config,
              ...payload,
            },
          },
        }),
      }
    }
    case SET_IS_PERSONAL_DATA_ALLOWED: {
      return {
        ...state,
        isPersonalDataAllowed: payload,
      }
    }
    default:
      return state
  }
}
